import { useStore } from 'zustand';
import {
  BusinessDistance,
  FinanceOption,
  PrivateDistance,
} from '../../../types';
import CarouselFuels from './CarouselFuels';
import { getStoreByKey } from './store/CarouselStore';
import {
  activeButtonClasses,
  buttonClasses,
  CarouselFieldsEnum,
} from './types/CarouselTypes';

interface Props {
  single?: boolean;
  uniqId: string;
}

const CarouselFilters = ({ single, uniqId }: Props) => {
  const {
    dispatch,
    selectedFinanceOption,
    selectedBusinessDistance,
    selectedPrivateDistance,
    showPrivateMileages,
    businessEditionFilter,
    options,
  } = useStore(getStoreByKey(uniqId));

  return (
    <div className="pb-10 flex flex-wrap gap-x-8 gap-y-4">
      {!single ? (
        <div>
          <h5 className="px-4 text-sm font-semibold mb-2">Drivlina</h5>
          <div className="flex gap-2 overflow-x-auto max-w-[100dvw] px-4">
            <CarouselFuels uniqId={uniqId} />
          </div>
        </div>
      ) : null}
      {!options && businessEditionFilter !== 'only' && (
        <div>
          <h5 className="px-4 text-sm font-semibold mb-2">Finansiering</h5>
          <div className="flex gap-2 overflow-x-auto max-w-[100dvw] px-4">
            <button
              onClick={() =>
                dispatch({ type: 'FINANCE_OPTION', payload: undefined })
              }
              className={`${buttonClasses} ${!selectedFinanceOption ? activeButtonClasses : null}`}
            >
              Alla
            </button>
            {Object.values(FinanceOption).map((option) => (
              <button
                key={option}
                className={`${buttonClasses} ${selectedFinanceOption === option ? activeButtonClasses : null}`}
                onClick={() =>
                  dispatch({
                    type: 'FINANCE_OPTION',
                    payload: option,
                  })
                }
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      )}
      {selectedFinanceOption === FinanceOption.BUSINESS && businessEditionFilter !== 'only' ? (
        <div>
          <h5 className="px-4 text-sm font-semibold mb-2">Årlig körsträcka</h5>
          <div className="flex gap-2 overflow-x-auto max-w-[100dvw] px-4">
            {Object.values(BusinessDistance).map((distance) => (
              <button
                key={distance}
                className={`${buttonClasses} ${selectedBusinessDistance === distance ? activeButtonClasses : null}`}
                onClick={() =>
                  dispatch({
                    type: 'BUSINESS_DISTANCE',
                    payload: distance,
                  })
                }
              >
                {distance}
              </button>
            ))}
          </div>
        </div>
      ) : null}
      {businessEditionFilter !== 'only' &&
      (selectedFinanceOption === FinanceOption.PRIVATE ||
        options?.fields.includes(CarouselFieldsEnum.PRIVATE_DESCRIPTION)) &&
      showPrivateMileages ? (
        <div>
          <h5 className="px-4 text-sm font-semibold mb-2">Årlig körsträcka</h5>
          <div className="flex gap-2 overflow-x-auto max-w-[100dvw] px-4">
            {Object.values(PrivateDistance).map((distance) => (
              <button
                key={distance}
                className={`${buttonClasses} ${selectedPrivateDistance === distance ? activeButtonClasses : null}`}
                onClick={() =>
                  dispatch({
                    type: 'PRIVATE_DISTANCE',
                    payload: distance,
                  })
                }
              >
                {distance}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CarouselFilters;
